<script setup lang="ts">

const breadcrumbData = [{
  title: 'Home',
  link: '/',
  subitems: [
    {title: 'Sobre-nós'}
  ]
}]
</script>

<template>
  <section class="bg-dark py-5" style="margin-top: -10px">
    <div class="container pt-0 pb-lg-5">
      <Breadcrumb :data="breadcrumbData"/>
      <div class="mb-lg-3 mx-auto text-center" style="max-width: 856px;">
        <h1 class="display-5 text-light mb-4 pb-lg-2 h1">
          Unimos organizadores de eventos aos seus participantes, facilitando a conexão entre quem cria
          <span class='text-primary h1'>experiências</span> e quem as <span class='text-primary h1'>vive</span>
        </h1>
        <p class="lead text-light opacity-70">Nossa missão é tornar mais fácil a organização de eventos e a aquisição de
          ingressos, aprimorando a experiência de nossos usuários em cada etapa.</p>
      </div>
    </div>
  </section>
</template>
